export const LANGUAGES = [
  { id: "fr", label: "Français", short: "FR" }, { id: "en", label: "English", short: "EN" }, { id: "es", label: "Español", short: "ES" },
  { id: "ca", label: "Català", short: "CA" }, { id: "it", label: "Italiano", short: "IT" }, { id: "pt", label: "Português", short: "PT" }, { id: "nl", label: "Nederlands", short: "NL" },
];
export const langLabel = (id) => LANGUAGES.find((l) => l.id === id)?.label || id;
const DATE_LOCALES = { fr: "fr-FR", en: "en-US", es: "es-ES", ca: "ca-ES", it: "it-IT", pt: "pt-PT", nl: "nl-NL" };
export const dateLocale = (id) => DATE_LOCALES[id] || "fr-FR";
